<div id="mijn-analyse" class="ap-flex ap-flex-column">
    @if (shownNotificationKey !== null) {
        <ap-notification
            [status]="keyNotificationMap.get(shownNotificationKey).state"
            [closeable]="keyNotificationMap.get(shownNotificationKey).closable"
        >
            {{ keyNotificationMap.get(shownNotificationKey).text }}
        </ap-notification>
    }
    <p>
        {{ 'mijn.analyse.modal.description' | apContent }}
    </p>

    @if (loading) {
        <ap-spinner
            class="ap-align-items-center"
            [loadingText]="'mijn.analyse.modal.loadingtext' | apContent"
            [readyText]="'mijn.analyse.modal.loadingtext.done' | apContent"
        ></ap-spinner>
    }

    @if (!loading) {
        <form>
            <h2 class="secondary">
                {{ 'mijn.analyse.modal.form.technicalInformation' | apContent }}
            </h2>
            <dl data-bb="url">
                <dt>{{ modalOptions.options.url.label }}</dt>
                <dd [innerHTML]="modalOptions.options.url.value"></dd>
            </dl>
            <dl data-bb="breadcrumb">
                <dt>{{ modalOptions.options.breadcrumb.label }}</dt>
                <dd [innerHTML]="modalOptions.options.breadcrumb.value"></dd>
            </dl>
            <dl data-bb="session">
                <dt>{{ modalOptions.options.session.label }}</dt>
                <dd [innerHTML]="modalOptions.options.session.value"></dd>
            </dl>
            <dl data-bb="customerID">
                <dt>{{ modalOptions.options.customerID.label }}</dt>
                <dd [innerHTML]="modalOptions.options.customerID.value"></dd>
            </dl>
            <dl data-bb="date">
                <dt>{{ modalOptions.options.date.label }}</dt>
                <dd [innerHTML]="modalOptions.options.date.value"></dd>
            </dl>
            <dl data-bb="browser">
                <dt>{{ modalOptions.options.browser.label }}</dt>
                <dd [innerHTML]="modalOptions.options.browser.value"></dd>
            </dl>
            <div [formGroup]="analyseForm">
                <ap-input [label]="'mijn.analyse.modal.subject.label' | apContent" formControlName="subject" data-bb="subject"> </ap-input>
                <ap-textarea data-bb="body" [label]="'mijn.analyse.modal.body.label' | apContent" formControlName="body"> </ap-textarea>
            </div>
            <div class="ap-margin-top-2">
                <ap-button type="button" variant="primary" iconName="envelope" (onClick)="openEmail()">
                    {{ 'mijn.analyse.modal.button.email.label' | apContent }}
                </ap-button>
                <ap-button type="button" variant="secondary" (click)="copyToClipboard()">
                    {{ 'mijn.analyse.modal.button.copy.label' | apContent }}
                </ap-button>
            </div>
            <p class="ap-small">
                {{ getFooterHelpText() }}
            </p>
        </form>
    }
</div>
